import { useSelector } from 'src/hooks/useSelector';

const useIsIframeView = (): boolean => {
    return useSelector((state) => state.router.location.query.iframe_view === 'true');
};

export default useIsIframeView;
